import fileDownload from 'js-file-download'
import {paginatedTransform, rawTransform} from 'src/services/skuit/utils'
import {Market} from '../../api/models'

import {API, CustomAxiosConfig} from './types'
import { ExportFilters } from 'src/services/skuit/types'

export interface ExportProps {
  fields: string[],
  exportFilters?: ExportFilters,
}
export class Markets {
  api: API
  key = 'market'

  constructor(api: API) {
    this.api = api
  }

  list = async (config: CustomAxiosConfig = {}) => {
    const response = await this.api.get('/logistics/markets', config)
    response.data = paginatedTransform(Market)(response.data)
    return response.data
  }

  retrieve = async (guid: string, config: CustomAxiosConfig = {}): Promise<Market> => {
    const response = await this.api.get(`/logistics/markets/${guid}`, config)
    return rawTransform(Market)(response.data)
  }

  create = async (data: any, config: CustomAxiosConfig = {}): Promise<Market> => {
    const response = await this.api.post('/logistics/markets', data, config)
    return rawTransform(Market)(response.data)
  }

  patch = async (guid: string, data: any, config: CustomAxiosConfig = {}): Promise<Market> => {
    const response = await this.api.patch(`/logistics/markets/${guid}`, data, config)
    return rawTransform(Market)(response.data)
  }

  export = async ({ fields }: ExportProps) => {
    const params = { fields: fields.join(',') }
    const response = await this.api.axiosInstance({
      url: '/logistics/markets/export',
      params,
      responseType: 'blob',
    })
    fileDownload(response.data, 'markets.csv')
  }
}
